import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Drawer,
  Pagination,
  PaginationItem,
  Alert,
  Snackbar,
  DialogTitle,
  TableRow,
  TableCell,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import AddRole from "./AddRole";
import ViewRole from "./ViewRole";
import User from "./User";
import DateRangePickerComponent from "./Filters/Date";
import { api, get, put } from "../../../utils/api";
import FilterSidebar from "../../../Components/Masters/Filter/FilterSidebar";
import ApplyButton from "./Filters/ApplyButton";
import CheckboxDrawer from "./Filters/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { styled } from "@mui/material/styles";
import ResetButton from "./Filters/ResetButton";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import { useUser } from "../../../context/AuthContext";
const Role = () => {
  const { user } = useUser();
  const [showUsers, setShowUsers] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [roleEdit, setRoleEdit] = useState(0);
  const [selectedUserIndex, setSelectedUserIndex] = useState(null);
  const [roles, setRoles] = useState([]); // Initialize roles as an empty array
  const [filteredRoles, setFilteredRoles] = useState([]); // Store filtered roles
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerOpenEdit, setIsDrawerOpenEdit] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteIndexEdit, setDeleteIndexEdit] = useState(0);
  const [allowPermision, setAllowPermission] = useState(false);
  const [index, setIndex] = useState(0);
  const [toggle, setToggle] = useState(false);
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [filterRoleNames, setFilterRoleNames] = useState([]); // Track selected roles for filtering
  const [startDate, setStartDate] = useState(null); // Start date state
  const [endDate, setEndDate] = useState(null); // End date state
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [selectedRoles, setSelectedRoles] = useState([]); // Store selected countries
  const [totalPages, setTotalPages] = useState(1);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Role: false,
  });
  const [errors, setErrors] = useState({
    Date: false,
    Role: false,
  });
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const filters = ["Date", "Role"];

  const fetchRoles = async (filters = filtersToApply) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const response = await get(`${api}/auth/getRoles?${queryParams}`);

      setRoles(response.data.data);
      setFilteredRoles(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [page, rowsPerPage, sortConfig]);

  const handleAddRole = (i) => {
    setIsDrawerOpen(true);
    setIndex(i);
  };

  const handleDelete = async () => {
    setDeleteDialog(true);
    // await put(`${api}/auth/DeleteRole?Id=${roleEdit._id}`)
    //   .then((res) => {
    //     setDeleteDialog(true);
    //     setAllowPermission(true);
    //     setFilteredRoles(
    //       filteredRoles.filter((item) => item._id !== res.data.data._id)
    //     );
    //   })
    //   .catch((err) => {
    //     if (
    //       err.response &&
    //       err.response.data &&
    //       err.response.data.message === "user not found"
    //     ) {
    //       setDeleteDialog(true);
    //       setAllowPermission(false);
    //     }
    //   });
    // setDeleteDialog(true);
    // setAllowPermission(false);
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const handleDeleteAggree = async (index) => {
    await put(`${api}/auth/DeleteRole?Id=${index}`)
      .then(async (res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setDeleteDialog(false);
        const updatedRoles = filteredRoles.filter(
          (item) => item._id !== res.data.data._id
        );
        setFilteredRoles(updatedRoles);

        // If roles count after deletion is less than rowsPerPage, fetch additional roles
        if (updatedRoles.length < rowsPerPage && page < totalPages) {
          const rolesToFetch = rowsPerPage - updatedRoles.length; // Calculate the number of roles to fetch
          try {
            const queryParams = new URLSearchParams({
              page: page + 1, // Fetch from the next page
              limit: rolesToFetch, // Fetch only the number of missing roles
              sortField: sortConfig.key,
              sortOrder: sortConfig.direction,
            }).toString();

            // const response = await axios.get(
            //   `${api}/auth/getRoles?${queryParams}`
            // );
            let response = await get(`/auth/getRoles?${queryParams}`);
            const nextPageRoles = response.data.data;

            // Append only the necessary roles to fill the current page
            setFilteredRoles((prevRoles) => [...prevRoles, ...nextPageRoles]);
          } catch (error) {
            console.error("Error fetching next page roles:", error);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setsnackOpen({
          open: true,
          message: err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
    setAnchorEl(null);
    setIndex(index);
    setSelectedUserIndex(null);
  };

  const handleRoleAssign = () => {
    setDeleteDialog(false);
    handleEdit();
  };

  const handleView = () => {
    setIndex(roleEdit._id);
    setAnchorEl(null);
    setSelectedUserIndex(null);
    setIsDrawerOpenEdit(true);
    // setIsDrawerOpen(false);
  };

  const handleEdit = () => {
    console.log("roleEditFRomEdit", roleEdit);
    setIndex(roleEdit);
    setAnchorEl(null);
    setSelectedUserIndex(null);
    setIsDrawerOpen(true);
    setIsDrawerOpenEdit(false);
  };

  const handleMenuClick = (event, index, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserIndex(index);
    setRoleEdit(data);
    setDeleteIndexEdit(
      // data.allowed_permissions.map((item) => item.name).join("") ===
      //   "delete Access"
      //   ? data._id
      //   : 0
      data._id
    );

    console.log(
      data.allowed_permissions.map((item) => item.name).join(""),
      "data++"
    );
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserIndex(null);
  };

  const open = Boolean(anchorEl);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleApplyFilters = () => {
    setPage(1); // Reset to the first page when applying filters
    fetchRoles();
    setDrawerFilterOpen(false);
    handleAppliedFilters();
  };

  // default filters to apply
  const filtersToApply = {
    name: selectedRoles.join(","),
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
  };

  const handleAppliedFilters = () => {
    setIsFiltersApplied(startDate || endDate || selectedRoles.length > 0);

    setAppliedFilters({
      ...appliedFilters,
      Date: startDate || endDate ? true : false,
      Role: selectedRoles.length > 0 ? true : false,
    });
  };

  // Applying reset filters
  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedRoles([]);
    setErrors({ Date: "", Role: "" });
    setAppliedFilters({ Date: false, Role: false });
    setIsFiltersApplied(false);
    fetchRoles({
      name: [],
      startDate: "",
      endDate: "",
    });
    setDrawerFilterOpen(false);
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            url={`${api}/auth/getRoles`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        ); // Date range picker component
      case "Role":
        return (
          <CheckboxDrawer
            {...{
              setSelectedRoles,
              selectedRoles,
              errors: errors.Role,
              setErrors,
            }}
          />
        ); // Checkbox filter for roles
      default:
        return (
          <DateRangePickerComponent
            url={`${api}/auth/getRoles`}
            {...{
              startDate,
              endDate,
              setStartDate,
              setEndDate,
              setErrors,
              errors: errors.Date,
            }}
          />
        );
    }
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const filterResetWithoutApply = () => {
    // Reset the selected filter only if changes were made
    if (selectedFilter === "Date") {
      setStartDate(null);
      setEndDate(null);
    } else if (selectedFilter === "Role") {
      setSelectedRoles([]); // Reset the 'facility' field
    }
    setDrawerFilterOpen(false); // Close the drawer without resetting everything
  };

  const handleFilterDrawer = () => {
    filterResetWithoutApply();
  };

  if (showUsers) {
    return <User />;
  }

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      <Box sx={{}}>
        <Snackbar
          open={snackOpen.open}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setsnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            // onClose={handleClose}
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
            {/* Add user Successfully */}
          </Alert>
        </Snackbar>

        <AddRole
          value={isDrawerOpen}
          setValue={setIsDrawerOpen}
          index={index}
          fetchRoles={fetchRoles}
          setsnackOpen={setsnackOpen}
        />
        <ViewRole
          values={isDrawerOpenEdit}
          setValues={setIsDrawerOpenEdit}
          index={index}
          handleEdit={handleEdit}
        />

        {/* Filter Drawer */}
        {drawerFilterOpen && (
          <Drawer
            anchor="right"
            open={drawerFilterOpen}
            onClose={handleFilterDrawer}
            sx={{
              backgroundColor: "transparent",
              "& .MuiDrawer-paper": {
                // This targets the paper component within the Drawer
                backgroundColor: "transparent", // Make paper transparent
                boxShadow: "none", // Optional: Remove any shadow
                width: "50%",
              },
            }}
          >
            <Box
              display="flex"
              gap={3}
              sx={{
                width: "100%",
                display: "flex",
                overflowX: "hidden",
                maxWidth: "100%",
                justifyContent: "space-btween",
                height: "100%",
                backgroundColor: "transparent",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#f5f5f5",
                  height: "3%",
                  padding: "13px",
                  margin: "30px 0 0 0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "80%",
                  width: "3%",
                }}
              >
                <IconButton
                  onClick={() => handleFilterDrawer()}
                  sx={{ color: "black" }}
                >
                  <CloseIcon sx={{ fontSize: "1.2rem" }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100vh",
                  overflow: "hidden",
                }}
              >
                {/* Sidebar for selecting the filter */}
                <FilterSidebar
                  {...{
                    setSelectedFilter,
                    selectedFilter,
                    filters,
                    appliedFilters,
                  }}
                />

                {/* Filter content area */}
                <Box
                  sx={{
                    flexGrow: 1,
                    backgroundColor: "#F9F9F9",
                    padding: "20px",
                    // overflow:"scroll",
                    height: "100vh",
                    paddingBottom: "20%",
                  }}
                >
                  {renderSelectedFilter()}
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      gap: "3%",
                      position: "fixed",
                      bottom: "20px",
                      ml: 3,
                      mr: 3,
                      mt: "10%",
                    }}
                  >
                    <ApplyButton handleApply={handleApplyFilters} />
                    <ResetButton handleReset={handleResetFilters} />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Drawer>
        )}

        {deleteDialog && allowPermision === false ? (
          <Dialog open={deleteDialog}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Do you really want to delete this entry?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDeleteDialog(false)} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => handleDeleteAggree(deleteIndexEdit)}
                color="secondary"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        ) : (
          <Dialog open={deleteDialog} onClose={() => setDeleteDialog(false)}>
            <DialogContent>
              <DialogContentText>
                Please assign this role before deleting it.
              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {console.log("deleteIndexEdit___", deleteIndexEdit)}
              <Button
                sx={{ textTransform: "none", fontSize: "16px" }}
                onClick={() => handleRoleAssign()}
              >
                Assign
              </Button>
            </DialogActions>
          </Dialog>
        )}

        <Box
          sx={{
            pt: "2rem",
            // display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                paddingLeft: "0",
              }}
            >
              {"Roles and Permissions"}
            </Typography>
          </Box>

          <Box
            sx={{
              pt: "2rem",
              width: "100%",
              marginBottom: "1.2rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Left Buttons */}
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => setShowUsers(true)}
                sx={{
                  backgroundColor: "#e0e0e0",
                  fontSize: "14px",
                  color: "black",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                }}
              >
                List of Users
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "14px",
                  color: "#FFFFFF",
                  textTransform: "none",
                }}
              >
                List of Roles
              </Button>
            </Box>

            {/* Right Buttons */}
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => setDrawerFilterOpen(true)}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                }}
              >
                Filter
                <FilterListIcon />
                {isFiltersApplied && (
                  <FiberManualRecordIcon
                    className="dot-icon"
                    sx={{
                      fontSize: "10px",
                      color: "#488257",
                      marginLeft: "5px",
                    }}
                  />
                )}
              </Button>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={() => handleAddRole(0)}
              >
                Add New
              </Button>
            </Box>
          </Box>
        </Box>

        <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: "20px",
              textAlign: "left",
              padding: "16px",
            }}
          >
            List of Roles
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "20% 30% 30% 20%",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            <Box
              sx={{
                padding: "8px 16px",
                fontWeight: "bold",
                textAlign: "left",
                borderRight: "1px solid #ddd",
                // borderBottom: "1px solid #ddd",
                display: "flex",
                flexDirection: "row",
              }}
            >
              Date
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "2px",
                  marginLeft: "10px",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => handleSort("createdAt", "asc")}
                >
                  <ExpandLess
                    sx={{
                      color:
                        sortConfig.key === "createdAt" &&
                        sortConfig.direction === "asc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleSort("createdAt", "desc")}
                >
                  <ExpandMore
                    sx={{
                      color:
                        sortConfig.key === "createdAt" &&
                        sortConfig.direction === "desc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "8px 12px",
                fontWeight: "bold",
                textAlign: "left",
                borderRight: "1px solid #ddd",
                // borderBottom: "1px solid #ddd",
                display: "flex",
                flexDirection: "row",
              }}
            >
              Name of Role
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "2px",
                  marginLeft: "10px",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => handleSort("name", "asc")}
                >
                  <ExpandLess
                    sx={{
                      color:
                        sortConfig.key === "name" &&
                        sortConfig.direction === "asc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleSort("name", "desc")}
                >
                  <ExpandMore
                    sx={{
                      color:
                        sortConfig.key === "name" &&
                        sortConfig.direction === "desc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "12px",
                fontWeight: "bold",
                textAlign: "left",
                borderRight: "1px solid #ddd",
                // borderBottom: "1px solid #ddd",
                display: "flex",
                flexDirection: "row",
              }}
            >
              Facility
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "2px",
                  marginLeft: "10px",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => handleSort("moduleName", "asc")}
                >
                  <ExpandLess
                    sx={{
                      color:
                        sortConfig.key === "moduleName" &&
                        sortConfig.direction === "asc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleSort("moduleName", "desc")}
                >
                  <ExpandMore
                    sx={{
                      color:
                        sortConfig.key === "moduleName" &&
                        sortConfig.direction === "desc"
                          ? "blue"
                          : "black",
                      margin: "-10px",
                      fontSize: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "12px",
                fontWeight: "bold",
                textAlign: "center",
                // borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </Box>
          </Box>

          {/* Table Body */}
          {filteredRoles?.length === 0 ? (
            <Box>
              <NoDataFound />
            </Box>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "20% 30% 30% 20%",
                width: "100%",
                //  border: "1px solid #ddd",
              }}
            >
              {filteredRoles.map((role, index) => (
                <>
                  <Typography
                    sx={{
                      padding: "8px 16px",
                      textAlign: "left",
                      borderRight: "1px solid #ddd",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      borderBottom: "1px solid #ddd",

                      fontSize: "14px",
                      color: "black",
                    }}
                  >
                    {/* {new Date(role.createdAt).toLocaleDateString()} */}
                    {new Date(role.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </Typography>

                  {/* <Box
                  key={`name-${index}`}
                  sx={{
                    padding: "2px 14px",
                    borderRight: "1px solid #ddd",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                > */}
                  <Typography
                    sx={{
                      padding: "8px 12px",
                      textAlign: "left",
                      borderRight: "1px solid #ddd",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      borderBottom: "1px solid #ddd",
                      fontSize: "14px",
                      color: "black",
                    }}
                  >
                    {role.name}
                  </Typography>
                  {/* </Box> */}

                  <Box
                    key={`permission-${index}`}
                    sx={{
                      padding: "8px 12px",
                      borderRight: "1px solid #ddd",
                      borderBottom: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "center",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      maxWidth: "100%", // Set a max width to control when to show ellipsis
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "black",
                        lineHeight: "1.5",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                      }}
                    >
                      {role?.facility ? role.facility.facilityName : "-"}
                    </Typography>
                  </Box>

                  <Typography
                    key={`action-${index}`}
                    sx={{
                      padding: "2px 8px 2px 8px",
                      textAlign: "center",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <IconButton
                      onClick={(event) => handleMenuClick(event, index, role)}
                    >
                      <MoreHorizIcon
                        sx={{ fontWeight: "bold", color: "black" }}
                      />
                    </IconButton>
                  </Typography>
                </>
              ))}
            </Box>
          )}
        </TableContainer>

        {/* Action Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              width: "120px",
              border: "1px solid #ddd",
              marginLeft: "-47px",
            },
          }}
        >
          {console.log("filteredRoles", filteredRoles, selectedUserIndex)}
          <MenuItem onClick={() => handleView()} sx={{ fontSize: "14px" }}>
            <AssignmentIcon sx={{ marginRight: "8px", fontSize: "large" }} />{" "}
            View Logs
          </MenuItem>
          <MenuItem onClick={() => handleEdit()} sx={{ fontSize: "14px" }}>
            <EditIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Edit
          </MenuItem>

          <MenuItem onClick={() => handleDelete()} sx={{ fontSize: "14px" }}>
            <DeleteIcon sx={{ marginRight: "8px", fontSize: "large" }} /> Delete
          </MenuItem>
        </Menu>

        {totalPages > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 3,
                backgroundColor: "#ffffff",
                width: "100%",
                // margin: "2% -0.5% 0% 23%",
                borderRadius: "2%",
                padding: "4px",
                marginBottom: "1rem",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                renderItem={(item) => (
                  <StyledPaginationItem
                    // <PaginationItem
                    {...item}
                    components={{
                      previous: () => (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mr: 27,
                          }}
                        >
                          <ArrowBackIcon sx={{ mr: 0.5, color: "green" }} />
                          Previous
                        </Box>
                      ),
                      next: () => (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            ml: 27,
                          }}
                        >
                          Next
                          <ArrowForwardIcon sx={{ ml: 0.5, color: "green" }} />
                        </Box>
                      ),
                    }}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        mx: 1,
                      },
                      "& .MuiPagination-ul": {
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
    </MainDashboardLayout>
  );
};

export default Role;
